import { articles } from "@/mocks/articles";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import HeroCarousel from "./components/HeroCarousel";
import FocusGrid from "./components/FocusGrid";
import CategoryEntries from "./components/CategoryEntries";
import LatestList from "./components/LatestList";
import HotPicks from "./components/HotPicks";
import BrandIntro from "./components/BrandIntro";

export default function Home() {
  const heroItems = [...articles].sort((a, b) => b.popularity - a.popularity).slice(0, 4);

  useDocumentMeta({
    title: "黑丝时尚搭配与潮流资讯 - 穿搭指南与最新趋势",
    description:
      "黑丝提供丰富的时尚搭配灵感、潮流资讯和穿搭指南，涵盖丝袜搭配技巧和流行风格，帮助用户展现独特魅力。",
    keywords: "黑丝,丝袜搭配,时尚穿搭,潮流资讯,穿搭技巧,时尚指南,流行趋势",
  });

  return (
    <div className="flex flex-col">
      <HeroCarousel items={heroItems} />
      <FocusGrid />
      <CategoryEntries />
      <LatestList />
      <HotPicks />
      <BrandIntro />
    </div>
  );
}